import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { ru } from 'vuetify/locale'
import { createVuetify, type ThemeDefinition } from 'vuetify'

const avoschoolLandingTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#5EBA5D',
    'primary-darken-1': '#3AA46B',
    'on-primary': '#FFFFFF',
    secondary: '#324252',
    'on-secondary': '#FFFFFF',
    success: '#2EAD67',
    info: '#2489D8',
    warning: '#F5B938',
    error: '#DE4B52',
    background: '#F7F8F5',
    'on-background': '#1F2933',
    surface: '#FFFFFF',
    'on-surface': '#1F2933',
    'surface-variant': '#EEF2EA',
    'on-surface-variant': '#5D6974',
    outline: '#D8DDD2',
  },
  variables: {
    'border-color': '#1F2933',
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.9,
    'medium-emphasis-opacity': 0.68,
    'hover-opacity': 0.05,
    'focus-opacity': 0.1,
    'selected-opacity': 0.09,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.14,
  },
}

export const vuetify = createVuetify({
  defaults: {
    VBtn: {
      color: 'primary',
      rounded: 'lg',
      style: 'text-transform: none; letter-spacing: 0;',
    },
    VTextField: {
      color: 'primary',
      density: 'comfortable',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VSelect: {
      color: 'primary',
      density: 'comfortable',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VTextarea: {
      color: 'primary',
      density: 'comfortable',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VCheckbox: {
      color: 'primary',
      hideDetails: 'auto',
    },
  },
  icons: {
    aliases,
    defaultSet: 'mdi',
    sets: { mdi },
  },
  locale: {
    locale: 'ru',
    fallback: 'ru',
    messages: { ru },
  },
  theme: {
    defaultTheme: 'avoschoolLanding',
    themes: {
      avoschoolLanding: avoschoolLandingTheme,
    },
  },
})
